const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const resolveMonth = d => monthNames[d.getMonth()];
